import { setDoc, doc } from "firebase/firestore";
import { db } from "../services/firebase";

export const SubmitLessonLog = async (data, userName, round, grade, week) => {
  const addField = await setDoc(doc(db, "LessonLog", userName), {
    name: userName,
  }).then((res) => {
    setDoc(
      doc(
        db,
        "LessonLog",
        userName,
        `Grade${grade}`,
        `week${week}`,
        "round",
        `round${round}`
      ),
      data
    );
  });
  return addField;
};
